export const NIC_TZ = "America/Managua";
export const MY_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const fmtIn = (iso, tz, opts = { weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) =>
  new Date(iso).toLocaleString(undefined, { ...opts, timeZone: tz });

export const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };

export function buildSessions(start, times) {
  return times.map((t, i) => {
    const [h, m] = t.split(":").map(Number);
    const d = addDays(start, i);
    d.setHours(h, m, 0, 0);
    return { day: i + 1, start_utc: d.toISOString() };
  });
}
